export const API_SERVER = process.env.REACT_APP_API_SERVER;
